import React, { useContext } from 'react'
import { Flex, Radio } from 'pcln-design-system'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { swap } from '@/shared-utils/ramda-helper'
import { SetValueFunctionType } from '@/types'
import { TripTypeInfos, TripTypeLabel } from './TripTypes'
import { PackagesFormStateType } from '../types'

const defaultTripTypes = Object.values(TripTypeInfos)
const mobileDefaultTripTypes = swap(1, 2, defaultTripTypes)

type TripTypeRadiosPropType = {
  setValue: SetValueFunctionType<PackagesFormStateType>
  watchTripType: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  register: Function
}

const TripTypeRadios = ({
  setValue,
  watchTripType,
  register
}: TripTypeRadiosPropType) => {
  const { isMobile = false } = useContext(BootstrapDataContext)
  const tripTypes = isMobile ? mobileDefaultTripTypes : defaultTripTypes

  return (
    <Flex
      alignItems={['left', null, 'center']}
      flexDirection={['column', null, 'row']}
      justifyContent="space-between"
    >
      <Flex flexDirection="row" flexWrap="wrap">
        {tripTypes.map(typeInfo => (
          <Flex
            mr={[0, null, 3]}
            alignItems="center"
            key={typeInfo.id}
            width={isMobile ? 1 / 2 : 'auto'}
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                id={typeInfo.id}
                type="radio"
                name="tripType"
                value={typeInfo.tripType}
                ref={register}
                checked={watchTripType === typeInfo.tripType}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setValue('tripType', e.target.value)
                }}
              />{' '}
              {typeInfo.typeLabel}
            </TripTypeLabel>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default TripTypeRadios
